import { makeStyles } from "@material-ui/core/styles";

const gameButtonGridStyles = makeStyles((theme) => ({
	gridItem: {
		width: "10%",
		padding: 2
	},
	gridContainer: {
		padding: 2
	},
	playerPositionToggle: {
		"& label": {
			marginLeft: 0,
			marginBottom: theme.spacing(1),
			"& span:nth-child(2)": {
				color: theme.palette.gameMode.primary
			}
		}
	}
}));

export default gameButtonGridStyles;
